import React, { useState, useEffect } from "react";
import {
  ThinTextField,
  ThinDropdownWithSearch,
} from "../common/GeneralComponent";
import { fetchData } from "../../utils/functions";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import Select from "react-select";

const WashWater = ({
  washWater: propWashWater,
  onChange,
  washInformationId,
  onUpdate,
}) => {
  const { id } = useParams();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [washWaterData, setWashWaterData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [updating, setUpdating] = useState(false);
  const [currentWashInfoId, setCurrentWashInfoId] = useState(null);
  const [washWaterId, setWashWaterId] = useState(null);
  const [isDqaApproved, setIsDqaApproved] = useState(false);
  const [isDqaRejected, setIsDqaRejected] = useState(false);
  const [washInfoData, setWashInfoData] = useState(null);
  const [validationErrors, setValidationErrors] = useState({});
  const [errors, setErrors] = useState({});

  const [formData, setFormData] = useState({
    number_of_household_served: "",
    number: "",
    type_of_water_source: "",
    use: "",
    use_for_irrigation: "",
    water_status: "",
    water_status_non_functional_since: "",
    water_used_in_hours: "",
    reliability_of_water_source: "",
    ownership: "",
    year_of_installation: "",
    accessibility: "",
    water_quality_monitoring: "",
    water_quality: "",
    operation_maintenance: "",
    number_of_people: "",
    roles_of_people: "",
    total_yearly_expenditure: "",
    maintenance_frequency: "",
    water_fees: "",
    water_fees_in_pkr: "",
    water_fees_percentage: "",
    past_floods: "",
    other_source_of_water_use: "",
    other_source_specify: "",
    other_source_functionality: "",
    other_source_people: "",
    pits_for_rain_water: "",
    waterborne_disease: "",
    hygiene_promotion: "",
    hygiene_promotion_specify: "",
    hygiene_promotion_other: "",
    disposal_of_latrine_waste: "",
    septic_tanks: "",
    longitude: "",
    latitude: "",
  });

  const getCurrentWashInfoId = () => washInformationId || id;

  // Helper functions for validation
  const isEmpty = (v) =>
    v === null || v === undefined || String(v).trim() === "";
  const isNumber = (v) => v !== "" && !isNaN(Number(v));
  const isGreaterThanOrEqual = (v, n) => Number(v) >= n;
  const isLessThanOrEqual = (v, n) => Number(v) <= n;
  const isBetween = (v, a, b) =>
    isNumber(v) && isGreaterThanOrEqual(v, a) && isLessThanOrEqual(v, b);
  const currentYear = new Date().getFullYear();

  const fetchWashInformationDetails = async (washInfoId) => {
    if (!washInfoId) return;

    try {
      const response = await fetchData(
        `wash-information/${washInfoId}`,
        "GET",
        null,
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );
      if (response?.data) {
        setWashInfoData(response.data);
        setIsDqaApproved(
          response.data.verified_from_dqa === 1 ||
            response.data.verified_from_dqa === "1"
        );
        setIsDqaRejected(
          response.data.verified_from_dqa === 2 ||
            response.data.verified_from_dqa === "2"
        );  
      }
    } catch (error) {
      console.error("Error fetching wash information details:", error);
    }
  };

  const resetForm = () => {
    setFormData({
      number_of_household_served: "",
      number: "",
      type_of_water_source: "",
      use: "",
      use_for_irrigation: "",
      water_status: "",
      water_status_non_functional_since: "",
      water_used_in_hours: "",
      reliability_of_water_source: "",
      ownership: "",
      year_of_installation: "",
      accessibility: "",
      water_quality_monitoring: "",
      water_quality: "",
      operation_maintenance: "",
      number_of_people: "",
      roles_of_people: "",
      total_yearly_expenditure: "",
      maintenance_frequency: "",
      water_fees: "",
      water_fees_in_pkr: "",
      water_fees_percentage: "",
      past_floods: "",
      other_source_of_water_use: "",
      other_source_specify: "",
      other_source_functionality: "",
      other_source_people: "",
      pits_for_rain_water: "",
      waterborne_disease: "",
      hygiene_promotion: "",
      hygiene_promotion_specify: "",
      hygiene_promotion_other: "",
      disposal_of_latrine_waste: "",
      septic_tanks: "",
      longitude: "",
      latitude: "",
    });
    setErrors({});
    setValidationErrors({});
    setWashWaterId(null);
  };

  const populateForm = (record) => {
    setWashWaterId(record.wash_water_id || null);

    setFormData({
      ...formData,
      number_of_household_served: record.number_of_household_served || "",
      number: record.number || "",
      type_of_water_source: record.type_of_water_source || "",
      use: record.use || "",
      use_for_irrigation: record.use_for_irrigation || "",
      water_status: record.water_status || "",
      water_status_non_functional_since:
        record.water_status_non_functional_since || "",
      water_used_in_hours: record.water_used_in_hours || "",
      reliability_of_water_source: record.reliability_of_water_source || "",
      ownership: record.ownership || "",
      year_of_installation: record.year_of_installation || "",
      accessibility: record.accessibility || "",
      water_quality_monitoring: record.water_quality_monitoring || "",
      water_quality: record.water_quality || "",
      operation_maintenance: record.operation_maintenance || "",
      number_of_people: record.number_of_people || "",
      roles_of_people: record.roles_of_people || "",
      total_yearly_expenditure: record.total_yearly_expenditure || "",
      maintenance_frequency: record.maintenance_frequency || "",
      water_fees: record.water_fees || "",
      water_fees_in_pkr: record.water_fees_in_pkr || "",
      water_fees_percentage: record.water_fees_percentage || "",
      past_floods: record.past_floods || "",
      other_source_of_water_use: record.other_source_of_water_use || "",
      other_source_specify: record.other_source_specify || "",
      other_source_functionality: record.other_source_functionality || "",
      other_source_people: record.other_source_people || "",
      pits_for_rain_water: record.pits_for_rain_water || "",
      waterborne_disease: record.waterborne_disease || "",
      hygiene_promotion: record.hygiene_promotion || "",
      hygiene_promotion_specify: record.hygiene_promotion_specify || "",
      hygiene_promotion_other: record.hygiene_promotion_other || "",
      disposal_of_latrine_waste: record.disposal_of_latrine_waste || "",

      // 👇 Fix here
      septic_tanks: Array.isArray(record.septic_tanks)
        ? record.septic_tanks[0] || ""
        : record.septic_tanks || "",
      longitude: record.longitude || "",
      latitude: record.latitude || "",
    });

    setErrors({});
    setValidationErrors({});
  };

  const fetchWashWaterData = async () => {
    const washInfoId = getCurrentWashInfoId();

    if (!washInfoId) {
      setLoading(false);
      return;
    }
    try {
      setLoading(true);

      await fetchWashInformationDetails(washInfoId);

      const response = await fetchData(
        "wash-water",
        "GET",
        null,
        { wash_information_id: washInfoId },
        {},
        navigate,
        "/wash",
        dispatch
      );
      const data = response?.data?.wash_water || [];
      setWashWaterData(data);

      const filteredData = data.filter(
        (item) => item.wash_information_id == washInfoId
      );

      if (filteredData.length > 0) {
        populateForm(filteredData[0]);
      } else {
        resetForm();
      }
    } catch (error) {
      console.error("Error fetching wash water data:", error);
      resetForm();
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    const newWashInfoId = getCurrentWashInfoId();
    if (newWashInfoId && newWashInfoId !== currentWashInfoId) {
      setCurrentWashInfoId(newWashInfoId);
      fetchWashWaterData();
    }
  }, [washInformationId, id]);

  const validateWaterUsedHours = (value) => {
    if (!value || value === "") return true;

    const numValue = parseInt(value, 10);
    if (isNaN(numValue) || !Number.isInteger(numValue)) {
      return "Must be a valid integer";
    }
    if (numValue < 0) {
      return "Cannot be negative";
    }
    if (numValue > 24) {
      return "Cannot exceed 24 hours";
    }
    return true;
  };

  const handleFieldChange = (fieldName, value) => {
    // Clear previous validation errors for this field (both types)
    if (validationErrors[fieldName]) {
      setValidationErrors((prev) => ({
        ...prev,
        [fieldName]: null,
      }));
    }

    // Clear form validation errors for this field
    if (errors[fieldName]) {
      setErrors((prev) => {
        const next = { ...prev };
        delete next[fieldName];
        return next;
      });
    }

    // Special validation for water_used_in_hours
    if (
      fieldName === "water_used_in_hours" &&
      (formData.water_status === "Fully functional" ||
        formData.water_status === "Partly functional")
    ) {
      const validationResult = validateWaterUsedHours(value);
      if (validationResult !== true) {
        setValidationErrors((prev) => ({
          ...prev,
          [fieldName]: validationResult,
        }));
        // Still update the form data to show the invalid value
      }
    }

    const updatedData = {
      ...formData,
      [fieldName]: value,
    };

    if (fieldName === "water_status" && value === "Non-functional") {
      updatedData.water_used_in_hours = "";
      // Clear validation errors for water_used_in_hours when status changes to non-functional
      setValidationErrors((prev) => ({
        ...prev,
        water_used_in_hours: null,
      }));

      const OM_REQUIRED = "There are person(s)/committee formally assigned";
      if (fieldName === "operation_maintenance") {
        if (value !== OM_REQUIRED) {
          setErrors((prev) => {
            const next = { ...prev };
            delete next.number_of_people;
            delete next.roles_of_people;
            delete next.total_yearly_expenditure;
            return next;
          });

          setValidationErrors((prev) => {
            const next = { ...prev };
            delete next.number_of_people;
            delete next.roles_of_people;
            delete next.total_yearly_expenditure;
            return next;
          });
          // (optional) clear values too
          updatedData.number_of_people = "";
          updatedData.roles_of_people = "";
          updatedData.total_yearly_expenditure = "";
        }
      }

      // Also clear form validation errors
      setErrors((prev) => {
        const next = { ...prev };
        delete next.water_used_in_hours;
        return next;
      });
    }

    setFormData(updatedData);

    if (onChange) {
      onChange(updatedData);
    }
  };

  // ---------- VALIDATION ----------
  const validate = () => {
    const e = {};

    if (isEmpty(formData.number_of_household_served)) {
      e.number_of_household_served = "Number of households served is required.";
    } else if (
      !isNumber(formData.number_of_household_served) ||
      !isGreaterThanOrEqual(formData.number_of_household_served, 1)
    ) {
      e.number_of_household_served = "Enter a valid number greater than 0.";
    }

    // if (isEmpty(formData.number)) {
    //   e.number = "Number is required.";
    // } else if (
    //   !isNumber(formData.number) ||
    //   !isGreaterThanOrEqual(formData.number, 1)
    // ) {
    //   e.number = "Enter a valid number greater than 0.";
    // }

    if (isEmpty(formData.type_of_water_source)) {
      e.type_of_water_source = "Type of water source is required.";
    }

    if (isEmpty(formData.use)) {
      e.use = "Use is required.";
    }

    if (isEmpty(formData.use_for_irrigation)) {
      e.use_for_irrigation = "Use for irrigation is required.";
    }

    if (isEmpty(formData.water_status)) {
      e.water_status = "Water status is required.";
    }

    if (formData.water_status === "Non-functional") {
      if (isEmpty(formData.water_status_non_functional_since)) {
        e.water_status_non_functional_since =
          "Non-functional days is required.";
      } else if (
        !isNumber(formData.water_status_non_functional_since) ||
        !isGreaterThanOrEqual(formData.water_status_non_functional_since, 0)
      ) {
        e.water_status_non_functional_since = "Enter a number ≥ 0.";
      }
    }

    if (
      formData.water_status === "Fully functional" ||
      formData.water_status === "Partly functional"
    ) {
      if (isEmpty(formData.water_used_in_hours)) {
        e.water_used_in_hours = "Water usage hours is required.";
      } else if (isNaN(formData.water_used_in_hours)) {
        e.water_used_in_hours = "Please enter a valid number.";
      } else if (
        Number(formData.water_used_in_hours) < 0 ||
        Number(formData.water_used_in_hours) > 24
      ) {
        e.water_used_in_hours = "Water usage hours must be between 0 and 24.";
      }
    }

    if (isEmpty(formData.reliability_of_water_source)) {
      e.reliability_of_water_source =
        "Reliability of water source is required.";
    }

    if (isEmpty(formData.ownership)) {
      e.ownership = "Ownership is required.";
    }

    if (isEmpty(formData.year_of_installation)) {
      e.year_of_installation = "Year of installation is required.";
    } else if (
      !isNumber(formData.year_of_installation) ||
      !isBetween(formData.year_of_installation, 1900, currentYear)
    ) {
      e.year_of_installation = `Enter a valid year (1900–${currentYear}).`;
    }

    if (isEmpty(formData.accessibility)) {
      e.accessibility = "Accessibility is required.";
    } else if (
      !isNumber(formData.accessibility) ||
      !isGreaterThanOrEqual(formData.accessibility, 0)
    ) {
      e.accessibility = "Enter a valid number ≥ 0.";
    }

    if (isEmpty(formData.water_quality_monitoring)) {
      e.water_quality_monitoring = "Water quality monitoring is required.";
    }

    if (isEmpty(formData.water_quality)) {
      e.water_quality = "Water quality is required.";
    }

    if (isEmpty(formData.operation_maintenance)) {
      e.operation_maintenance = "Operation and maintenance is required.";
    }

    if (
      formData.operation_maintenance ===
      "There are person(s)/committee formally assigned"
    ) {
      if (isEmpty(formData.number_of_people)) {
        e.number_of_people = "Number of people is required.";
      } else if (
        !isNumber(formData.number_of_people) ||
        !isGreaterThanOrEqual(formData.number_of_people, 1)
      ) {
        e.number_of_people = "Enter a number ≥ 1.";
      }

      if (isEmpty(formData.roles_of_people)) {
        e.roles_of_people = "Roles of people is required.";
      }

      if (isEmpty(formData.total_yearly_expenditure)) {
        e.total_yearly_expenditure = "Total yearly expenditure is required.";
      } else if (
        !isNumber(formData.total_yearly_expenditure) ||
        !isGreaterThanOrEqual(formData.total_yearly_expenditure, 0)
      ) {
        e.total_yearly_expenditure = "Enter a number ≥ 0.";
      }
    }

    if (isEmpty(formData.maintenance_frequency)) {
      e.maintenance_frequency = "Maintenance frequency is required.";
    }

    if (isEmpty(formData.water_fees)) {
      e.water_fees = "Water fees is required.";
    }

    // ✅ Only validate related fields if water_fees is "Yes"
    if (formData.water_fees === "Yes") {
      if (isEmpty(formData.water_fees_in_pkr)) {
        e.water_fees_in_pkr = "Water fees amount is required.";
      } else if (
        !isNumber(formData.water_fees_in_pkr) ||
        !isGreaterThanOrEqual(formData.water_fees_in_pkr, 0)
      ) {
        e.water_fees_in_pkr = "Enter a number ≥ 0.";
      }

      if (isEmpty(formData.water_fees_percentage)) {
        e.water_fees_percentage = "Water fees percentage is required.";
      } else if (
        !isNumber(formData.water_fees_percentage) ||
        !isBetween(formData.water_fees_percentage, 0, 100)
      ) {
        e.water_fees_percentage = "Enter a percentage between 0–100.";
      }
    } else if (formData.water_fees === "No") {
      // ✅ If "No", clear related errors & values
      delete e.water_fees_in_pkr;
      delete e.water_fees_percentage;
    }

    if (isEmpty(formData.past_floods)) {
      e.past_floods = "Past floods information is required.";
    }

    if (isEmpty(formData.other_source_of_water_use)) {
      e.other_source_of_water_use = "Other source of water use is required.";
    }

    if (formData.other_source_of_water_use === "Yes") {
      if (isEmpty(formData.other_source_specify)) {
        e.other_source_specify = "Other source specification is required.";
      }

      if (isEmpty(formData.other_source_functionality)) {
        e.other_source_functionality =
          "Other source functionality is required.";
      }

      if (isEmpty(formData.other_source_people)) {
        e.other_source_people = "Other source people information is required.";
      }
    }

    if (isEmpty(formData.pits_for_rain_water)) {
      e.pits_for_rain_water = "Pits for rain water is required.";
    }

    if (isEmpty(formData.waterborne_disease)) {
      e.waterborne_disease = "Waterborne disease information is required.";
    }

    if (isEmpty(formData.hygiene_promotion)) {
      e.hygiene_promotion = "Hygiene promotion is required.";
    }

    const hp = formData.hygiene_promotion;
    if (
      hp ===
        "Yes, it was carried out for different groups(adults, men/women/children) in the past" ||
      hp === "Other (specify)"
    ) {
      if (isEmpty(formData.hygiene_promotion_specify)) {
        e.hygiene_promotion_specify =
          "Please specify hygiene promotion details.";
      }
    }

    if (isEmpty(formData.hygiene_promotion_other)) {
      e.hygiene_promotion_other = "Hygiene promotion other is required.";
    }

    if (isEmpty(formData.disposal_of_latrine_waste)) {
      e.disposal_of_latrine_waste = "Disposal of latrine waste is required.";
    }

    if (isEmpty(formData.septic_tanks)) {
      e.septic_tanks = "Septic tanks information is required.";
    }

    setErrors(e);
    return Object.keys(e).length === 0;
  };

  const handleUpdate = async () => {
    // Check for validation errors before submitting
    const hasValidationErrors = Object.values(validationErrors).some(
      (error) => error !== null
    );
    if (hasValidationErrors) {
      return;
    }

    // Run form validation
    if (!validate()) {
      // toast.error("Please fix the highlighted errors.");
      return;
    }

    try {
      setUpdating(true);
      const washInfoId = getCurrentWashInfoId();

      const updateData = {
        ...formData,
        wash_information_id: washInfoId,
      };

      if (
        formData.operation_maintenance !==
        "There are person(s)/committee formally assigned"
      ) {
        delete updateData.number_of_people;
        delete updateData.roles_of_people;
        delete updateData.total_yearly_expenditure;
      }

      const endpoint = washWaterId
        ? `wash-water/${washWaterId}`
        : `wash-water/wash-info/${washInfoId}`;

      const response = await fetchData(
        endpoint,
        "PUT",
        updateData,
        {},
        {},
        navigate,
        "/wash",
        dispatch
      );
      if (response?.success) {
        toast.success("Wash water information updated successfully");

        if (onUpdate) {
          onUpdate(response.data);
        }

        await fetchWashWaterData();
      } else {
        throw new Error(
          response?.message || "Failed to update wash water information"
        );
      }
    } catch (error) {
      console.error("Error updating wash water:", error);
      toast.error(error.message || "Error updating wash water information");
    } finally {
      setUpdating(false);
    }
  };

  const waterSourceOptions = [
    { label: "Tap water", value: "Tap water" },
    { label: "Hand pump", value: "Hand pump" },
    { label: "Protected dug well", value: "Protected dug well" },
    { label: "Unprotected dug well", value: "Unprotected dug well" },
    { label: "Rainwater collection", value: "Rainwater collection" },
    { label: "Surface water", value: "Surface water" },
    { label: "Leadline", value: "Leadline" },
    { label: "Direct", value: "Direct" },
  ];

  const useOptions = [
    { label: "Drinking only", value: "Drinking only" },
    {
      label: "Drinking and domestic use (washing, cooking, etc.)",
      value: "Drinking and domestic use (washing, cooking, etc.)",
    },
    {
      label: "Domestic use (washing, cooking, etc.) only",
      value: "Domestic use (washing, cooking, etc.) only",
    },
  ];

  const statusOptions = [
    { label: "Fully functional", value: "Fully functional" },
    { label: "Partly functional", value: "Partly functional" },
    { label: "Non-functional", value: "Non-functional" },
  ];

  const reliabilityOptions = [
    { label: "Year-round", value: "Year-round" },
    { label: "Seasonal", value: "Seasonal" },
  ];

  const ownershipOptions = [
    { label: "Communal", value: "Communal" },
    { label: "Private", value: "Private" },
  ];

  const waterQualityMonitoringOptions = [
    {
      label: "Regular testing by the local authority in charge of testing",
      value: "Regular testing by the local authority in charge of testing",
    },
    {
      label: "Community based regular monitoring",
      value: "Community based regular monitoring",
    },
    { label: "No regular monitoring", value: "No regular monitoring" },
    { label: "No monitoring", value: "No monitoring" },
  ];

  const waterQualityOptions = [
    {
      label: "Tested and safe for its uses",
      value: "Tested and safe for its uses",
    },
    {
      label: "Tested and unsafe for its uses",
      value: "Tested and unsafe for its uses",
    },
    {
      label: "Untested but considered safe for its uses",
      value: "Untested but considered safe for its uses",
    },
    {
      label: "Untested and considered unsafe for its uses",
      value: "Untested and considered unsafe for its uses",
    },
  ];

  const operationMaintenanceOptions = [
    {
      label: "There are person(s)/committee formally assigned",
      value: "There are person(s)/committee formally assigned",
    },
    {
      label:
        "In case of need, there is somebody the community or the individuals can easily hire",
      value:
        "In case of need, there is somebody the community or the individuals can easily hire",
    },
    {
      label: "Nobody oversees operation and maintenance",
      value: "Nobody oversees operation and maintenance",
    },
  ];

  const maintenanceFrequencyOptions = [
    {
      label: "Regularly (according to a plan)",
      value: "Regularly (according to a plan)",
    },
    {
      label: "Occasionally (without a set pattern, when there are issues)",
      value: "Occasionally (without a set pattern, when there are issues)",
    },
    { label: "Never", value: "Never" },
  ];

  const pastFloodsOptions = [
    { label: "Yes, with no damages", value: "Yes, with no damages" },
    {
      label: "Yes, with damages not compromising its functionality",
      value: "Yes, with damages not compromising its functionality",
    },
    {
      label:
        "Yes, with damages affecting its functionality but it was repaired",
      value:
        "Yes, with damages affecting its functionality but it was repaired",
    },
    {
      label:
        "Yes, with damages affecting its functionality and it was not repaired",
      value:
        "Yes, with damages affecting its functionality and it was not repaired",
    },
    { label: "No", value: "No" },
    {
      label:
        "No, because it was made after the flood, but it is not clear if it is flood resilient",
      value:
        "No, because it was made after the flood, but it is not clear if it is flood resilient",
    },
    {
      label:
        "No, because it was made after the flood, and it is flood resilient",
      value:
        "No, because it was made after the flood, and it is flood resilient",
    },
  ];

  const hygienePromotionOptions = [
    {
      label: "Yes, most of the children do it at school",
      value: "Yes, most of the children do it at school",
    },
    {
      label:
        "Yes, it was carried out for different groups(adults, men/women/children) in the past",
      value:
        "Yes, it was carried out for different groups(adults, men/women/children) in the past",
    },
    { label: "No", value: "No" },
    { label: "Others", value: "other" },
  ];

  const septicTanksOptions = [
    { label: "Availability", value: "availability" },
    { label: "Design", value: "design" },
    { label: "Functionality", value: "functionality" },
    { label: "Cleaning", value: "cleaning" },
    { label: "N/A", value: "N/A" },
  ];

  if (loading) {
    return (
      <div className="flex justify-center items-center h-64">
        <div className="text-lg text-gray-600">Loading wash water data...</div>
      </div>
    );
  }

  // Error renderer function (same pattern as WashInformation)
  const Err = (name) =>
    errors?.[name] ? (
      <p className="text-red-600 text-sm mt-1">{errors[name]}</p>
    ) : null;

  return (
    <>
      <div className="flex justify-between items-center mb-6">
        <h2 className="text-teal-700 text-xl font-semibold">Wash Water</h2>
        {isDqaApproved && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
            Approved from DQA
          </span>
        )}
        {isDqaRejected && (
          <span className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full text-sm font-semibold">
            Rejected from DQA
          </span>
        )}
      </div>

      <form className="w-full">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div>
            <ThinTextField
              label="Latitude"
              type="number"
              value={formData.latitude}
              onChange={(e) => handleFieldChange("latitude", e.target.value)}
              disabled
            />
            {Err("latitude")}
          </div>

          <div>
            <ThinTextField
              label="Longitude"
              type="number"
              value={formData.longitude}
              onChange={(e) => handleFieldChange("longitude", e.target.value)}
              disabled
            />
            {Err("longitude")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Number of Households Served"
              type="number"
              value={formData.number_of_household_served}
              onChange={(e) => {
                const val = e.target.value;
                if (
                  val === "" ||
                  (/^\d{0,5}$/.test(val) && Number(val) <= 32767)
                ) {
                  handleFieldChange("number_of_household_served", val);
                }
              }}
            />
            {Err("number_of_household_served")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Type of Water Source"
              id="water-source"
              options={waterSourceOptions}
              value={formData.type_of_water_source}
              onChange={(value) =>
                handleFieldChange("type_of_water_source", value)
              }
            />
            {Err("type_of_water_source")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Use"
              id="use"
              options={useOptions}
              value={formData.use}
              onChange={(value) => handleFieldChange("use", value)}
            />
            {Err("use")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Use for Irrigation?
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`use_for_irrigation_${currentWashInfoId}`}
                  value="Yes"
                  checked={formData.use_for_irrigation === "Yes"}
                  onChange={(e) =>
                    handleFieldChange("use_for_irrigation", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`use_for_irrigation_${currentWashInfoId}`}
                  value="No"
                  checked={formData.use_for_irrigation === "No"}
                  onChange={(e) =>
                    handleFieldChange("use_for_irrigation", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("use_for_irrigation")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Status of water source"
              id="water-status"
              options={statusOptions}
              value={formData.water_status}
              onChange={(value) => handleFieldChange("water_status", value)}
            />
            {Err("water_status")}
          </div>

          {formData.water_status === "Non-functional" && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Non-functional since (days)"
                type="number"
                value={formData.water_status_non_functional_since}
                onChange={(e) =>
                  handleFieldChange(
                    "water_status_non_functional_since",
                    e.target.value
                  )
                }
              />
              {Err("water_status_non_functional_since")}
            </div>
          )}

          {(formData.water_status === "Fully functional" ||
            formData.water_status === "Partly functional") && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Water Used (hours per day)"
                type="number"
                value={formData.water_used_in_hours}
                onChange={(e) => {
                  const val = e.target.value;
                  if (val === "" || (Number(val) >= 0 && Number(val) <= 24)) {
                    handleFieldChange("water_used_in_hours", val);
                  }
                }}
                min="0"
                max="24"
                step="1"
              />
              {Err("water_used_in_hours")}
              {validationErrors.water_used_in_hours && (
                <p className="mt-1 text-sm text-red-600">
                  {validationErrors.water_used_in_hours}
                </p>
              )}
            </div>
          )}

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Reliability of Water Source"
              id="reliability"
              options={reliabilityOptions}
              value={formData.reliability_of_water_source}
              onChange={(value) =>
                handleFieldChange("reliability_of_water_source", value)
              }
            />
            {Err("reliability_of_water_source")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Ownership"
              id="ownership"
              options={ownershipOptions}
              value={formData.ownership}
              onChange={(value) => handleFieldChange("ownership", value)}
            />
            {Err("ownership")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Year of Installation"
              type="number"
              value={formData.year_of_installation}
              onChange={(e) =>
                handleFieldChange("year_of_installation", e.target.value)
              }
            />
            {Err("year_of_installation")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Accessibility"
              type="number"
              value={formData.accessibility}
              onChange={(e) =>
                handleFieldChange("accessibility", e.target.value)
              }
            />
            {Err("accessibility")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Water Quality Monitoring"
              id="water-quality-monitoring"
              options={waterQualityMonitoringOptions}
              value={formData.water_quality_monitoring}
              onChange={(value) =>
                handleFieldChange("water_quality_monitoring", value)
              }
            />
            {Err("water_quality_monitoring")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Water Quality"
              id="water-quality"
              options={waterQualityOptions}
              value={formData.water_quality}
              onChange={(value) => handleFieldChange("water_quality", value)}
            />
            {Err("water_quality")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Operation and Maintenance"
              id="operation-maintenance"
              options={operationMaintenanceOptions}
              value={formData.operation_maintenance}
              onChange={(value) =>
                handleFieldChange("operation_maintenance", value)
              }
            />
            {Err("operation_maintenance")}
          </div>

          {formData.operation_maintenance ===
            "There are person(s)/committee formally assigned" && (
            <>
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Number of People"
                  type="number"
                  value={formData.number_of_people}
                  onChange={(e) =>
                    handleFieldChange("number_of_people", e.target.value)
                  }
                />
                {Err("number_of_people")}
              </div>

              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Roles of People"
                  value={formData.roles_of_people}
                  onChange={(e) =>
                    handleFieldChange("roles_of_people", e.target.value)
                  }
                />
                {Err("roles_of_people")}
              </div>

              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Total Yearly Expenditure (PKR)"
                  type="number"
                  value={formData.total_yearly_expenditure}
                  onChange={(e) =>
                    handleFieldChange(
                      "total_yearly_expenditure",
                      e.target.value
                    )
                  }
                />
                {Err("total_yearly_expenditure")}
              </div>
            </>
          )}

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Maintenance Frequency"
              id="maintenance-frequency"
              options={maintenanceFrequencyOptions}
              value={formData.maintenance_frequency}
              onChange={(value) =>
                handleFieldChange("maintenance_frequency", value)
              }
            />
            {Err("maintenance_frequency")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Water Fees?
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`water_fees_${currentWashInfoId}`}
                  value="Yes"
                  checked={formData.water_fees === "Yes"}
                  onChange={(e) =>
                    handleFieldChange("water_fees", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`water_fees_${currentWashInfoId}`}
                  value="No"
                  checked={formData.water_fees === "No"}
                  onChange={(e) =>
                    handleFieldChange("water_fees", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("water_fees")}
          </div>

          {formData.water_fees === "Yes" && (
            <>
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="How much and how often PKR/(HH month)"
                  value={formData.water_fees_in_pkr}
                  onChange={(e) =>
                    handleFieldChange("water_fees_in_pkr", e.target.value)
                  }
                />
                {Err("water_fees_in_pkr")}
              </div>
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="What is percentage of HH paying"
                  type="number"
                  value={formData.water_fees_percentage}
                  onChange={(e) =>
                    handleFieldChange("water_fees_percentage", e.target.value)
                  }
                />
                {Err("water_fees_percentage")}
              </div>
            </>
          )}

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="The water source was affected by the past floods"
              id="past-floods"
              options={pastFloodsOptions}
              value={formData.past_floods}
              onChange={(value) => handleFieldChange("past_floods", value)}
            />
            {Err("past_floods")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Other Source of Water Use?
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`other_source_of_water_use_${currentWashInfoId}`}
                  value="Yes"
                  checked={formData.other_source_of_water_use === "Yes"}
                  onChange={(e) =>
                    handleFieldChange(
                      "other_source_of_water_use",
                      e.target.value
                    )
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`other_source_of_water_use_${currentWashInfoId}`}
                  value="No"
                  checked={formData.other_source_of_water_use === "No"}
                  onChange={(e) =>
                    handleFieldChange(
                      "other_source_of_water_use",
                      e.target.value
                    )
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("other_source_of_water_use")}
          </div>

          {formData.other_source_of_water_use === "Yes" && (
            <>
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Other Source Specify"
                  value={formData.other_source_specify}
                  onChange={(e) =>
                    handleFieldChange("other_source_specify", e.target.value)
                  }
                />
                {Err("other_source_specify")}
              </div>
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Other Source Functionality"
                  value={formData.other_source_functionality}
                  onChange={(e) =>
                    handleFieldChange(
                      "other_source_functionality",
                      e.target.value
                    )
                  }
                />
                {Err("other_source_functionality")}
              </div>
              <div>
                <ThinTextField disabled={isDqaApproved || isDqaRejected}
                  label="Other Source People"
                  value={formData.other_source_people}
                  onChange={(e) =>
                    handleFieldChange("other_source_people", e.target.value)
                  }
                />
                {Err("other_source_people")}
              </div>
            </>
          )}

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Pits for Rain Water?
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`pits_for_rain_water_${currentWashInfoId}`}
                  value="Yes"
                  checked={formData.pits_for_rain_water === "Yes"}
                  onChange={(e) =>
                    handleFieldChange("pits_for_rain_water", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`pits_for_rain_water_${currentWashInfoId}`}
                  value="No"
                  checked={formData.pits_for_rain_water === "No"}
                  onChange={(e) =>
                    handleFieldChange("pits_for_rain_water", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("pits_for_rain_water")}
          </div>

          <div className="mt-6">
            <p className="mb-2 text-sm font-medium text-gray-700">
              Any estimate of waterborne disease?
            </p>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`waterborne_disease_${currentWashInfoId}`}
                  value="Yes"
                  checked={formData.waterborne_disease === "Yes"}
                  onChange={(e) =>
                    handleFieldChange("waterborne_disease", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">Yes</span>
              </label>
              <label className="flex items-center gap-1">
                <input disabled={isDqaApproved || isDqaRejected}
                  type="radio"
                  name={`waterborne_disease_${currentWashInfoId}`}
                  value="No"
                  checked={formData.waterborne_disease === "No"}
                  onChange={(e) =>
                    handleFieldChange("waterborne_disease", e.target.value)
                  }
                  className="accent-blue-600"
                />
                <span className="text-sm text-gray-700">No</span>
              </label>
            </div>
            {Err("waterborne_disease")}
          </div>

          <div>
            <ThinDropdownWithSearch disabled={isDqaApproved || isDqaRejected}
              label="Hygiene Promotion?"
              id="hygiene-promotion"
              options={hygienePromotionOptions}
              value={formData.hygiene_promotion}
              onChange={(value) =>
                handleFieldChange("hygiene_promotion", value)
              }
            />
            {Err("hygiene_promotion")}
          </div>

          {(formData.hygiene_promotion ===
            "Yes, it was carried out for different groups(adults, men/women/children) in the past" ||
            formData.hygiene_promotion === "other") && (
            <div>
              <ThinTextField disabled={isDqaApproved || isDqaRejected}
                label="Hygiene Promotion Specify"
                value={formData.hygiene_promotion_specify}
                onChange={(e) =>
                  handleFieldChange("hygiene_promotion_specify", e.target.value)
                }
              />
              {Err("hygiene_promotion_specify")}
            </div>
          )}

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Hygiene Promotion Other"
              value={formData.hygiene_promotion_other}
              onChange={(e) =>
                handleFieldChange("hygiene_promotion_other", e.target.value)
              }
            />
            {Err("hygiene_promotion_other")}
          </div>

          <div>
            <ThinTextField disabled={isDqaApproved || isDqaRejected}
              label="Disposal of Latrine Waste"
              value={formData.disposal_of_latrine_waste}
              onChange={(e) =>
                handleFieldChange("disposal_of_latrine_waste", e.target.value)
              }
            />
            {Err("disposal_of_latrine_waste")}
          </div>

          <div>
            <p className="mb-2 text-sm font-medium text-gray-700">
              Septic Tanks
            </p>
            <div className="grid grid-cols-2 gap-2">
              {septicTanksOptions.map((option) => (
                <label key={option.value} className="flex items-center gap-2">
                  <input disabled={isDqaApproved || isDqaRejected}
                    type="radio"
                    name="septic_tanks" // all radios share same name
                    value={option.value}
                    checked={formData.septic_tanks === option.value}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        septic_tanks: e.target.value,
                      })
                    }
                    className="accent-blue-600"
                  />
                  <span className="text-sm text-gray-700">{option.label}</span>
                </label>
              ))}
            </div>
            {Err("septic_tanks")}
          </div>
        </div>

        {!isDqaApproved && !isDqaRejected && (
          <div className="mt-8 flex justify-end gap-4">
            <button
              type="button"
              onClick={handleUpdate}
              disabled={updating}
              className={`${
                updating ? "bg-gray-400" : "bg-teal-600 hover:bg-teal-700"
              } text-white px-4 py-2 rounded-lg transition duration-200 font-medium`}
            >
              {updating ? "Updating..." : "Update"}
            </button>
          </div>
        )}
      </form>
    </>
  );
};

export default WashWater;
